/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Counter } from '../models/Counter';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CounterService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns Counter
     * @throws ApiError
     */
    public counterRetrieve(): CancelablePromise<Counter> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/counter/',
        });
    }

}
